import { render, staticRenderFns } from "./ContentIcon.vue?vue&type=template&id=910c6ee4&scoped=true&"
import script from "./ContentIcon.vue?vue&type=script&lang=js&"
export * from "./ContentIcon.vue?vue&type=script&lang=js&"
import style0 from "./ContentIcon.vue?vue&type=style&index=0&id=910c6ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910c6ee4",
  null
  
)

export default component.exports